import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { MenuItem } from "./types";
import { ModeToggle } from "@/components/ModeToggle";
import { HeaderWallet } from "./HeaderWallet";

interface MobileNavProps {
  user: any;
  menuItems: MenuItem[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleNavigation: (path: string) => void;
  handleSignOut: () => void;
}

export const MobileNav = ({ 
  user, 
  menuItems, 
  isOpen, 
  setIsOpen, 
  handleNavigation, 
  handleSignOut 
}: MobileNavProps) => {
  return (
    <div className="md:hidden">
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon">
            <Menu className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-[85vw] sm:w-[385px] p-0 bg-white dark:bg-slate-950">
          <nav className="flex flex-col gap-4 p-4">
            <div className="flex items-center gap-2 pb-4 border-b">
              <img 
                src="/LogoPorteroYa.svg" 
                alt="PorteroYa Logo" 
                className="h-14 w-auto"
              />
              <span className="text-xl font-bold text-primary">PorteroYa</span>
            </div>
            
            {user && (
              <div className="pb-4 border-b">
                <HeaderWallet />
              </div>
            )}

            {user ? (
              <>
                {menuItems.map((item) => (
                  <Button
                    key={item.path}
                    variant="ghost"
                    className="w-full justify-start text-base text-gray-900 dark:text-gray-100 hover:text-primary active:text-secondary transition-colors duration-200"
                    onClick={() => handleNavigation(item.path)}
                  >
                    {item.path === '/notifications' ? 'Notifications' : (item.icon || item.label)}
                  </Button>
                ))}
                <div className="flex items-center justify-start py-2">
                  <ModeToggle />
                </div>
                <Button 
                  variant="outline" 
                  className="w-full mt-2 text-gray-900 dark:text-gray-100 hover:text-primary active:text-secondary transition-colors duration-200"
                  onClick={handleSignOut}
                >
                  Sign Out
                </Button>
              </>
            ) : (
              <>
                <div className="flex items-center justify-start py-2">
                  <ModeToggle />
                </div>
                <Button
                  variant="ghost"
                  className="w-full text-base text-gray-900 dark:text-gray-100 hover:text-primary active:text-secondary transition-colors duration-200"
                  onClick={() => handleNavigation("/login")}
                >
                  Login
                </Button>
                <Button
                  className="w-full text-base hover:text-primary active:text-secondary transition-colors duration-200"
                  onClick={() => handleNavigation("/register")}
                >
                  Register
                </Button>
              </>
            )}
          </nav>
        </SheetContent>
      </Sheet>
    </div>
  );
};